import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import React from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";

const StyledElementGroup = styled.div<IProps>`
  border-radius: ${(props) => props.theme.radii[0]};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    padding: 0 0.2rem 0.2rem;
    border: 0;
    background-image: linear-gradient(
      to right,
      ${(props) =>
          props.theme.colors.elementTypes[props.elementTypeId].colors[0]}
        75%,
      ${(props) =>
        props.theme.colors.elementTypes[props.elementTypeId].colors[1]}
    );
  }
`;

const ElementGroupHeading = styled.h3<IProps>`
  margin: 0;
  padding: ${(props) => props.theme.space[1]};
  background-color: ${(props) => props.theme.colors.greyBlue};
  color: black;
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: bold;
  text-transform: capitalize;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${(props) => props.theme.radii[0]};
  }

  ${(props) =>
    props.elementTypeId &&
    css`
      background-image: linear-gradient(
        to right,
        ${props.theme.colors.elementTypes[props.elementTypeId].colors[0]} 75%,
        ${props.theme.colors.elementTypes[props.elementTypeId].colors[1]}
      );
      color: white;
    `};
`;

const ElementGroupBody = styled.div<IProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) =>
    props.$justifyContentCenter ? "center" : "space-around"};
  padding: ${(props) => props.theme.space[2]} 0;
  border-bottom: 2px solid
    ${(props) => props.theme.colors.elementTypes[props.elementTypeId].colors[1]};
  background-color: ${(props) => props.theme.colors.greyWhite};
  background-repeat: no-repeat;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border: 0;
    border-radius: ${(props) => props.theme.radii[0]};
  }
`;
interface IProps {
  elementTypeId: number;
  $showBackground?: boolean;
  $justifyContentCenter?: boolean;
  children?: React.ReactNode;
}

const ElementGroup: React.FC<IProps> = ({
  children,
  elementTypeId = 0,
  $showBackground = true,
  $justifyContentCenter = true,
}) => {
  const elementTypesById = useSelector(getElementTypesById);
  const elementType = elementTypesById[elementTypeId];
  return (
    <StyledElementGroup elementTypeId={elementTypeId}>
      {elementTypeId && (
        <ElementGroupHeading elementTypeId={elementTypeId}>
          {elementType.plural_name}
        </ElementGroupHeading>
      )}
      <ElementGroupBody
        elementTypeId={elementTypeId}
        $showBackground={$showBackground}
        $justifyContentCenter={$justifyContentCenter}
      >
        {children}
      </ElementGroupBody>
    </StyledElementGroup>
  );
};

export default ElementGroup;
